module.exports = __webpack_public_path__ + "images/stickers/taco-pixel.9044b8e8153407d9c351.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-pixel.png
// module id = TWiE
// module chunks = 0